import request from "@/utils/request";

export function createContest(data) {
  return request({
    url: "/contest/private",
    method: "post",
    data
  });
}

export function getContest() {
  return request({
    url: "/contest/private",
    method: "get"
  });
}

export function deleteContest(id) {
  return request({
    url: "/contest/private/" + id,
    method: "delete"
  });
}

export function updateContest(contestId, data) {
  return request({
    url: "/contest/private/" + contestId,
    method: "put",
    data
  });
}

export function updateWinners(data) {
  return request({
    url: "/contest/private/update-winners",
    method: "post",
    data
  });
}

export function getWinners() {
  return request({
    url: "/contest/private/get-winners",
    method: "get"
  });
}

export function getParticipants(id) {
  return request({
    url: "/contest/private/participants/" + id,
    method: "get"
  });
}

export function updateParticipant(part) {
  return request({
    url: "/contest/private/participants/" + part.id,
    method: "put",
    data: part
  });
}

export function downloadParticipants(id) {
  return request({
    url: "/contest/private/participants/" + id + "/download",
    method: "post"
  }, {
    responseType: 'blob'
  });
}
